import '.ar{flex-shrink:0;}.ssr-plugin'
import '.ay{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ax{height:100%;}.ssr-plugin'
import '.au{border:none;}.ssr-plugin'
import '.cz{background-color:transparent;}.ssr-plugin'
import '.d0{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.bm{position:sticky;}.ssr-plugin'
import '.d1{top:4rem;}.ssr-plugin'
import '.d2{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.d3{padding-bottom:1rem;}.ssr-plugin'
import '.d4{margin-bottom:1rem;}.ssr-plugin'
import '.d5{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.bu{left:0px;}.ssr-plugin'
import '.bv{right:0px;}.ssr-plugin'
import '.bw{bottom:0px;}.ssr-plugin'
import '.cw{z-index:9999;}.ssr-plugin'
import '.cx{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b7{justify-content:flex-end;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ar ay n ax au cz d0"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e r"
    >
      <div className="bm d1 d2 v d3 d4 d5 d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bn bu bv bw cw v cx d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ay d b7 d5"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="az c5">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
